import { DEFAULT_LOCALE, isLocaleCode, type AuthSession, type User } from '@sshop/domain';

import type { AuthSessionDto, UserDto } from './auth.dto';

/**
 * One-way translators: DTO → domain. Never the reverse.
 *
 * Outbound payloads (login form, register form) are built directly from domain inputs
 * inside the adapter — they're trivial and don't warrant a mapper layer.
 */
export function toUser(dto: UserDto): User {
  return {
    id: dto.id,
    email: dto.email,
    name: dto.name,
    firstName: dto.first_name,
    surname: dto.surname,
    idNumber: dto.id_number,
    address: dto.address,
    phone: dto.phone,
    hasPassword: dto.has_password,
    locale: isLocaleCode(dto.locale) ? dto.locale : DEFAULT_LOCALE,
    roles: dto.roles,
    createdAt: dto.created_at,
  };
}

export function toAuthSession(dto: AuthSessionDto): AuthSession {
  return {
    user: toUser(dto.user),
    token: dto.token,
    expiresAt: dto.expires_at,
  };
}
